'use strict';

var React = require('react');

module.exports = {

    childContextTypes: {
        layout: React.PropTypes.string,
        validateOnSubmit: React.PropTypes.bool,
        validatePristine: React.PropTypes.bool,
        rowClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
        labelClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
        elementWrapperClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object])
    },

    getChildContext: function getChildContext() {
        return {
            layout: this.props.layout || 'horizontal',
            validateOnSubmit: this.props.validateOnSubmit || false,
            validatePristine: this.props.validatePristine || false,
            rowClassName: this.props.rowClassName || '',
            labelClassName: this.props.labelClassName || '',
            elementWrapperClassName: this.props.elementWrapperClassName || ''
        };
    },

    getLayoutClassName: function getLayoutClassName() {
        return 'form-' + this.getChildContext().layout;
    }

};


//////////////////
// WEBPACK FOOTER
// ./~/formsy-react-components/release/mixins/parent-context.js
// module id = 695
// module chunks = 0